// extracted by mini-css-extract-plugin
export default {"root":"root--82611c4","loader":"loader--bf38d61"};